module.exports = __webpack_public_path__ + "img/shopping-cart-1.69f102bb.svg";